import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TDropdown } from 'src/app/project/components/dropdown/dropdown.consts';
import { TAccount } from 'src/app/project/modules/account/account.model';
import { TPointsByWorkspace } from 'src/app/project/modules/points/points.model';
import { TWorkspace, TWorkspacesById } from 'src/app/project/modules/workspace/workspace.model';

import { TimelineGroupingDropdownComponent } from './timeline-grouping-dropdown/timeline-grouping-dropdown.component';

import { DropdownService } from '../../../components/dropdown/dropdown-service/dropdown.service';
import { PointHalfModalService } from '../../points/point-half-modal/point-half-modal.service';
import { SiteDataService, TSiteData } from '../site-data.service';

import { ScreenService } from '@core/services';
import { TPreferences } from 'src/app/project/modules/preferences/preferences.model';
import { EUserRole } from 'src/app/project/modules/share/share-utils/user-roles';
import { EStore } from 'src/app/project/shared/enums/store.enum';
import { EIconPath } from '../../../shared/enums/icons.enum';
import { PreferencesService } from '../../preferences/preferences-service/preferences.service';
import Timeline from '../site-timeline/Timeline';
import { GET_TIMELINE } from '../site-timeline/timeline.ui.store';
import { ResetTimelineService } from './reset-timeline-button/reset-timeline.service';
import { TableLoadingService } from '../site-table/custom-table/table-loading.service';

@Component({
  selector: 'pp-timeline-options',
  templateUrl: './timeline-options.component.html',
  styleUrls: ['./timeline-options.component.scss'],
  standalone: false,
})
export class TimelineOptionsComponent implements OnInit, OnDestroy {
  @Input() ppDataFetched = false;
  @Input() ppIsOverview = false;
  @Input() ppTimelinePointsLength = 0;

  private site: TSiteData = this.siteDataService.getSite();

  private workspaceId: string = null;
  workspaces$: Observable<TWorkspacesById>;
  workspace: TWorkspace;
  private account: TAccount;
  groupingHovered = false;
  groupingDropdownVisible = false;

  public sitePlanExists = true;
  preferences: TPreferences;
  EUserRole = EUserRole;
  EIconPath = EIconPath;
  timelineGrouped = false;
  timelinePointsLength = 0;

  private readonly destroy$ = new Subject<void>();
  private dropdown: TDropdown = this.dropdownService.getDropdown();
  isLoadingTable = false;
  private points$: Observable<TPointsByWorkspace>;
  private preferences$: Observable<TPreferences>;
  timeline: Timeline;

  constructor(
    private store: Store<{
      workspaces: TWorkspacesById;
      points: TPointsByWorkspace;
      preferences: TPreferences;
      accounts: TAccount[];
    }>,
    private activatedRoute: ActivatedRoute,
    private pointHalfModalService: PointHalfModalService,
    private siteDataService: SiteDataService,
    private dropdownService: DropdownService,
    private screenService: ScreenService,
    private preferencesService: PreferencesService,
    private resetTimelineService: ResetTimelineService,
    private tableLoadingService: TableLoadingService,
  ) {
    this.workspaces$ = this.store.pipe(select(EStore.WORKSPACES));
    this.points$ = this.store.pipe(select(EStore.POINTS));
    this.preferences$ = this.store.pipe(select(EStore.PREFERENCES));

    this.tableLoadingService.isTableLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoading) => {
        this.isLoadingTable = isLoading;
      });
  }

  ngOnInit() {
    this.timelineGrouped = this.preferencesService.getPreferences()?.timeline?.group !== null;

    this.preferences$.pipe(takeUntil(this.destroy$)).subscribe((preferences) => {
      this.preferences = preferences;

      this.timelineGrouped = preferences?.timeline?.group !== null;
    });

    this.activatedRoute.paramMap.subscribe((params) => {
      this.workspaceId = params.get('id');
    });

    this.workspaces$.pipe(takeUntil(this.destroy$)).subscribe((workspaces) => {
      this.sitePlanExists = !!workspaces?.[this.workspaceId]?.sitePlan;

      if (workspaces[this.workspaceId] && workspaces[this.workspaceId].loadedFullWorkspace) {
        this.workspace = workspaces[this.workspaceId];

        const { isDesktop } = this.screenService.getCurrentState();

        if (isDesktop && !this.sitePlanExists) {
          this.site.sitePlanVisible = false;
        }

        if (!this.sitePlanExists) {
          this.pointHalfModalService.hideModal();
        }
      } else if (!this.workspaceId) {
        this.sitePlanExists = false;
      }
    });

    this.points$.pipe(takeUntil(this.destroy$)).subscribe((pointsStore) => {
      this.timeline = GET_TIMELINE();

      // this needs to filter the points OR we use prop instead...
      this.timelinePointsLength = Object.values(pointsStore).flatMap(
        (points) => points.entities,
      )?.length;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  resetTimeline(): void {
    this.resetTimelineService.resetTimeline();
  }
  toggleGroupingDropdown(buttonId: string): void {
    if (!this.ppDataFetched) {
      return;
    }

    if (this.dropdown.visible && this.dropdown.buttonId === buttonId) {
      this.groupingDropdownVisible = false;
      this.dropdownService.hideDropdown();
    } else {
      this.groupingDropdownVisible = true;

      this.dropdownService.showDropdown(buttonId, TimelineGroupingDropdownComponent, {
        suppressScrollbar: true,

        onClose: () => {
          this.groupingDropdownVisible = false;
        },
      });
    }
  }

  //
  // More dropdown
  //

  groupingHover(): void {
    this.groupingHovered = true;
  }

  groupingHoverEnd(): void {
    this.groupingHovered = false;
  }
}
